import { createStyles, makeStyles, Theme } from 'styles/utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    footer: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      marginTop: 'auto',
      '& div': {
        padding: 0,
      },
    },
  }),
);

export default useStyles;
